import { defineMessages } from 'react-intl';

import { BillingProductBlockReason } from '@/entities/organization';

import { DiagnocoinHistoryFilter } from './types';

export const addDiagnocoinsBlockReasonMessages =
  defineMessages<BillingProductBlockReason>({
    noPermission: {
      id: 'diagnocoins.addNoPermissionTooltip',
      defaultMessage: 'You do not have permission to add Diagnocoins.',
    },
  });

export const diagnocoinHistoryFilterMessages =
  defineMessages<DiagnocoinHistoryFilter>({
    [DiagnocoinHistoryFilter.all]: {
      id: 'diagnocoins.history.filter.all',
      defaultMessage: 'All',
    },
    [DiagnocoinHistoryFilter.purchases]: {
      id: 'diagnocoins.history.filter.purchases',
      defaultMessage: 'Purchases',
    },
    [DiagnocoinHistoryFilter.deductions]: {
      id: 'diagnocoins.history.filter.deductions',
      defaultMessage: 'Deductions',
    },
    [DiagnocoinHistoryFilter.refunds]: {
      id: 'diagnocoins.history.filter.refunds',
      defaultMessage: 'Refunds',
    },
  });

export const diagnocoinsMessages = defineMessages({
  autoDeductionTitle: {
    id: 'diagnocoins.autoDeduction.title',
    defaultMessage: 'Automatic deduction',
  },
  autoDeductionAdminHint: {
    id: 'diagnocoins.autoDeduction.adminHint',
    defaultMessage:
      'Lets the partner API and the desktop app spend coins without asking once the subscription limit runs out. Orders placed in a browser always ask first. The clinic changes this in its own billing settings, not from here.',
  },
  topUpsTitle: {
    id: 'diagnocoins.topUps.title',
    defaultMessage: 'Top-ups',
  },
  batchPurchased: {
    id: 'diagnocoins.batch.purchasedColumn',
    defaultMessage: 'Purchased',
  },
  batchTotal: {
    id: 'diagnocoins.batch.totalColumn',
    defaultMessage: 'Total',
  },
  batchRemaining: {
    id: 'diagnocoins.batch.remainingColumn',
    defaultMessage: 'Remaining',
  },
  batchExpires: {
    id: 'diagnocoins.batch.expiresColumn',
    defaultMessage: 'Expires',
  },
  historyTitle: {
    id: 'diagnocoins.history.title',
    defaultMessage: 'Diagnocoins history',
  },
  historyEmpty: {
    id: 'diagnocoins.history.empty',
    defaultMessage: 'No transactions yet',
  },
  historyFailed: {
    id: 'diagnocoins.history.failed',
    defaultMessage: 'Could not load the transaction history',
  },
  historyDate: {
    id: 'diagnocoins.history.dateColumn',
    defaultMessage: 'Date',
  },
  historyType: {
    id: 'diagnocoins.history.typeColumn',
    defaultMessage: 'Type',
  },
  historyChange: {
    id: 'diagnocoins.history.changeColumn',
    defaultMessage: 'Change',
  },
  historyAvailableAfter: {
    id: 'diagnocoins.history.availableAfterColumn',
    defaultMessage: 'Available after',
  },
  viewHistory: {
    id: 'diagnocoins.viewHistory',
    defaultMessage: 'View transaction history',
  },
  subtract: {
    id: 'diagnocoins.batch.subtract',
    defaultMessage: 'Subtract',
  },
});
